import ProjectTables from "../../components/dashboard/ProjectTable";

const Tables = () => {
  return (
    <ProjectTables/>
  );
};

export default Tables;
